import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=b0bc92b0"
import script from "./Ship.vue?vue&type=script&lang=js"
export * from "./Ship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports